/**
 * Enumération des type de géolocalisation possibles
 */
export enum TypeGeolocalisation {
    DISABLED = 'DISABLED',
    VIA_MICHELIN = 'VIA_MICHELIN',
    GOOGLE_MAPS = 'GOOGLE_MAPS',
}